import { Storage, StorageGetConfig, StorageGetOutput } from "@aws-amplify/storage";
import { useStore } from ".";
import axios from "axios";
const bucketName = "murderhungrystories190715-dev";

export function getLocalizedStorage<T extends Record<string, any> & {
    download?: boolean;
}>(name: string, extension: string, config?: StorageGetConfig<T>): StorageGetOutput<T> {
    const store = useStore();

    return Storage.get(`${name}_${store.state.locale}.${extension}`, config);
}

export function getLocalized(name: string, extension: string){
    const store = useStore();
    const url = `https://${bucketName}.s3.amazonaws.com/public/${name}_${store.state.locale}.${extension}`;
    console.log( `download ${url}`);
    return axios.get(url);
}
